module.exports = __webpack_public_path__ + "img/location-smile.de607d74.svg";